import React from 'react';

import { Events } from 'App/Tracking/Events';
import { FilterKey, FiltersCollection } from 'Book/shared';
import {
  FeaturedPractitionerCardList,
  StandardPractitionerCardList,
} from './components';

export interface PractitionerCardListProps {
  featured?: boolean;
  filters?: FiltersCollection;
  /** The most recently added filter, offered for removal when no practitioners match */
  lastAddedFilterKey?: FilterKey;
  onRemoveFilter?(key: FilterKey): void;
  limit?: number;
  trackingEvent?: Events;
}

export const PractitionerCardList = ({
  featured = false,
  ...props
}: PractitionerCardListProps) => {
  if (featured) {
    return <FeaturedPractitionerCardList {...props} />;
  }

  return <StandardPractitionerCardList {...props} />;
};
